import {create} from 'zustand';
import {UseUploadedFilesStore} from './types';
import {IFile} from '../../types';

const useUploadedFilesStore = create<UseUploadedFilesStore>(set => ({
	uploadedFiles: [],
	resetUploadedFiles: () => set({uploadedFiles: []}),
	updateFile: (attachmentId: string, data: Partial<IFile>) =>
		set(state => ({
			uploadedFiles: state.uploadedFiles.map(file =>
				file.id === attachmentId ? {...file, ...data} : file,
			),
		})),
	addFiles: (newFiles: IFile[]) =>
		set(state => ({
			uploadedFiles: [...state.uploadedFiles, ...newFiles],
		})),
	removeFile: (attachmentId: string) =>
		set(state => ({
			uploadedFiles: state.uploadedFiles.filter(file => file.id !== attachmentId),
		})),
	removeFilesWithError: () =>
		set(state => ({
			uploadedFiles: state.uploadedFiles.filter(file => file.error === false),
		})),
}));

export {useUploadedFilesStore};
